//Imports fichiers js
try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

} catch (e) {}

require('./lazyload');
require('./friconix');
require('./HeaderSticky');
require('./FooterSticky');
require('./breadcrumb');
require('./BackToTop');
require('./AncreScroll');
require('./FormAjax');
require('./InputSelect');
